module.exports = __webpack_public_path__ + "static/media/imgziliao@2x.f81b345f.png";